import React, { FC, useState } from 'react';
import { Body, Box, Divider, Stack } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import { Link as GatsbyLink } from 'gatsby';
import { FooterContact } from './FooterContact';
import FooterMobileItems from './FooterMobileItems';
import { FooterProps } from './types';
import { AICPA_LINK } from '../../../constants';
import BottomLinksMobile from './BottomLinksMobile';

export interface FooterMobileProps extends FooterProps {}

const FooterMobile: FC<FooterMobileProps> = ({
  contact,
  copyrightText,
  footerBottomItems,
  links,
}) => {
  const [activeTabLabel, setActiveTabLabel] = useState<string | null>(null);

  function handleActiveTab(label: string) {
    if (activeTabLabel === label) setActiveTabLabel(null);
    else setActiveTabLabel(label);
  }

  return (
    <Box flexDir="column" w="100%">
      <Box flexDir="column" px={500}>
        <FooterContact {...contact} />
        <Stack py={500} d={{ desktop: 'none', base: 'flex' }}>
          <Divider
            opacity={1}
            borderColor="brandNavy.300"
            orientation="horizontal"
            borderWidth="1px"
            borderTopWidth={0}
            my={0}
          />
          {links.map(navItem => (
            <FooterMobileItems
              label={navItem.label}
              links={navItem.links}
              key={navItem.label}
              isOpen={activeTabLabel === navItem.label}
              onToggle={() => {
                handleActiveTab(navItem.label);
              }}
            />
          ))}
        </Stack>
        <Box
          mt={600}
          display="flex"
          flexWrap="wrap"
          justifyContent="space-between"
          alignItems="center"
          pb={700}
        >
          {footerBottomItems.map(({ label, to }) =>
            to.length ? (
              <BottomLinksMobile
                key={label}
                isExternalLink={to.includes('https://')}
                linkTo={to}
                label={label}
              />
            ) : (
              <Body
                key={label}
                minW="29%"
                my={300}
                textAlign="center"
                flexGrow={1}
                letterSpacing="0.15em"
                cursor="pointer"
                className="ot-sdk-show-settings"
                color="brandNavy.200"
                _hover={{ color: 'primary.500' }}
                _active={{ color: 'primary.300' }}
                size={300}
                fontWeight="bodyBold"
                textTransform="uppercase"
              >
                {label}
              </Body>
            ),
          )}
        </Box>
      </Box>
      <Divider
        borderColor="brandNavy.300"
        orientation="horizontal"
        opacity={1}
        borderWidth="1px"
        borderTopWidth={0}
        my={0}
      />
      <Box
        py={500}
        px={500}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Body
          color="brandNavy.200"
          size={300}
          isSemiBold
          as={GatsbyLink}
          to="https://hover.to/"
        >
          {copyrightText}
        </Body>
        <a href={AICPA_LINK} aria-label="soc logo">
          <StaticImage
            placeholder="blurred"
            src="../../../assets/images/soc_logo.png"
            alt="SOC logo service organization"
            width={56}
            height={56}
          />
        </a>
      </Box>
    </Box>
  );
};

export default FooterMobile;
